export const pl = {
  // CYCLES
  cycles: {
    cycles: [
      "STRUCTURAL COLLAGE",
      "INTERIOR",
      "EGG DOMINATION",
      "RZEŹBA",
      //"POEZJA",
      "INNE",
    ],
  },

  // ERROR
  error: {
    errorHeader: "Nie znaleziono strony",
    errorButton: "Wróć na stronę główną",
  },

  // GDPR
  cookieBanner: {
    cookieBannerParagraph:
      "Używamy ciasteczek aby wygodniej korzystało Ci się z tej strony. Kontynuując, akceptujesz politykę prywatności.",
    cookieBannerLink: "Dowiedz się więcej",
    cookieBannerButton: "Rozumiem",
  },

  // MENU
  menu: {
    menuButton: "MENU",
    closeMenuButton: "ZAMKNIJ",
    artworksMenuButton: "Prace",
    exhibitionsMenuButton: "Wystawy",
    biographyMenuButton: "O mnie",
    contactMenuButton: "Kontakt",
    backToMainPage: "Powrót",
    backToExhibitionsPage: "Powrót do wystaw",
    backToCyclesPage: "Powrót do cykli",
  },

  poetry: {
    "0001": {
      metaTitle: "W strukturze mroku",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, W strukturze mroku",
      poetryBookId: "0001",
      poetryBookTitle: "W strukturze mroku",
      poetryBookCycle: "POEZJA",
      poetryBookImages: {
        "0001-1": "images/0001/0001-1.jpg",
      },
      poems: {
        Aberracja: `Moja głowa, jak pochodnia,
spala tysiąc, może więcej wspomnień oraz doznań.
Ja wiem ona już nie lubi ciszy, instrumentalnej głuszy.
Tworzy wielki betonowy mur, dla mojej duszy.
Jest zagadką, klęską, cudem.
Męką mego życia, łonem mojej sztuki.
Jest wyrazem mego ja, lecz czasami mnie katuje paraliżującym bólem.
Niczym monolit z kosmicznego dna, 
chłonie steki pytań o sens istnienia… 
`,
        Źrenica: `Źrenica to lustro twojej duszy, pokus i uciech.
Źrenica to twój największy zdrajca, obnażający twe sumienie.
Źrenica to studnia dla twoich łez.
Źrenica to fizyczna cząstka kosmosu wprawiająca twoje ciało w drżenie.
Źrenica to niewolnica i ofiara strachu też.
Źrenica to miejsce gdzie mieszka adrenalina.
Źrenica to fotograf z twojego życia.
Źrenica to serce dla twoich oczu, to niezdetonowana mina.
Źrenica to przyjaciółka obłędu, grająca o najwyższą stawkę bez pokrycia.
Źrenica to mała cząstka Ciebie, to mechaniczny twór, dzięki któremu spostrzegasz świat.
Źrenica to mały element siebie, który pod wpływem bólu, doświadczeń, płowieje z biegiem lat.
`,
        Fabryka: `Dotyka moich oczu, dotyka moich uszu, dotyka moich ust.
Ociera się o moje płuca, przykleja mi do twarzy szereg
nowych zmartwień i bruzd.

W wodospadach świateł, rozpływa się po halach, głuchy
stukot bicia metalowych serc.

Fabryka to atrapa świata i życia, w której nie istnieje
czas, miejsce, przestrzeń i lata.

W wodospadach świateł nie czuć niczyjej duszy, lecz
metalowe cielsko, które do życia, jedynie energetyczny impuls poruszy.

Świat ten nie jest kolorowy, lecz ponury.
W powietrzu unosi się zapach ludzkiego cwaniactwa, wyzysku
i trutki na szczury.

W wodospadach świateł po betonowych schodach zaprogramowani na 
szarą codzienność, wędrują ludzie, niczym blaszane drwale,
pozbawieni wiary i nadziei, pracują ciężej, szybciej, trwale.
`,
        Ułuda: `Już nie zatańczy na mym grobie,
Dziewczyna w koralach z ludzkich marzeń.
Nie ulegnę jej hipnotyzującej głębi zielonych, 
kocich oczu.
Mam dosyć iluzji, mam dosyć jej świata, 
chcę przebić tę błonę, co mnie otacza.
Ułuda złodziejka nadziei, marzeń i życia.
Trzymała mnie pod szklanym kloszem, 
dusząc i wypaczając moje idee i myśli.
Monotonią przyprawiała całą szarą rzeczywistość,
przenikając mnie od stóp po mózg, 
wcierała we mnie chełpliwie niepewność i lęk.
Lecz obudziłem się we śnie!
Nie będę Ikarem z woskowymi skrzydłami!
Metalowy charaktery moich tytanowych skrzydeł,
wznosi mnie ponad obłudną ułudę.
Nie ma przede mną już barier żadnych.
Zmartwychwstałem, czuje się silny i gotowy.
Ułudo won z mojej duszy, won z mojej głowy.
`,
        Jesień: `Cztery pory roku, a wśród nich jesień. 
Kolorowo - ponura, ciepło – zimna, sentymentalno-agresywna.
Jesień córka wiatru, znów nam niesie:
Szelest pastelowych liści, 
Wino-grono-nowe kiści,
Dezercję ptactwa wszelkiego rodzaju,
Pracowite kominy,
Twarz obrażonego nieba,
Ciepły golf na szyi,
Zapach zza rogu pieczonego chleba.

Cztery pory roku, a wśród nich jesień,
Kobieta o wielu twarzach, 
Bywa, że jak bezwzględna Meduza.
Wiatrem, siłą podmuchu, wilgocią nas odurza.
Lub jak ciepła opiekunka Hestia,
Stwarza nam domowe ognisko i nie ważna jest reszta.

Cztery pory roku, a wśród nich jesień
Matka trzech synów: Październik, Listopad,
A wśród nich najbardziej kochany Wrzesień.
Lubią ją gusła za rożne duchy,
Lubią ją dzieci za kasztany,
Lubią latawce za gwałtowne podmuchy,
Lubią rolnicy za urodzaj udany.
Jesień lubię i ja za jej schizofreniczny nastrój i 
niebagatelny czar.
`,
        Miłość: `Miłość jest jak dzika bestia.
Seksowna, agresywna, lubieżna,
lubi, jak się ją rozpieszcza.
Rozgrzanym pazurem przez ślady czasu,
sama sobie prawa nakreśla.
`,
        Harmonia: `Znów spokój i cisza harmonijnie we mnie wnika.
Błękitne niebo z ogromnymi ptakami nadchodzi i znika.
Sam już nie wiem kiedy śpię, a kiedy oczy zamykam.
Czuje, że znów natura siłą mnie obdarza.
I nie karze się obnażać z moich wiotkich marzeń, jak palce 
deszczu, rozmytych w każdą stronę świata.
Dusza, jak człowiek ma coś do zrobienia.
Naszą rzeczą jest dialog, jej potrzeba siebie wyrażenia.
`,
        "Ze szpitalnych rozmyślań...": `Gdzie się zaczynasz?
Gdzie się twój wielki sen rozpoczyna?
Czy w myślach twoich?
Czy w twoich czynach?
Kogo to wina?
Ogromny obszar istnienia….
…..zbierania myśli w worek bez dna.
Głuche i ślepe.
Małe i chore.
Smutne i tkliwe.
A gdzie się kończysz?
Tam gdzie zaczynasz?
`,
        "Wszyscy jesteśmy bestiami": `Demon na nas siadł 
i nas zjadł…
Powziął nas głęboko i
zepchnął w otchłań szeroką.

Wszyscy jesteśmy bestiami. 
Wszyscy nosimy jego znamię.

Demon na nas siadł 
I nas skradł…
Czarnym skrzydłem przykrył ognia blask.
Wydziobał oczy, wyrąbał maszt.
Po jego śladzie, pył kurz i trzask.

Wszyscy jesteśmy bestiami.
Wszyscy w uśpieniu czekamy.
`,
        Pustka: `










Nic.














`,
        Opętanie: `Kiedy przyjdzie opętanie,
niech ktoś założy mi kryształowy kaganiec.

Niech ktoś przykryje mnie kołdrą nicości,
posypie proszkiem ultra świadomości.

Niech ktoś zaśpiewa, niech ktoś zatańczy,
niech ktoś wypatroszy me rządze…

Niech ktoś rozliczy me opętanie i 
rzuci w końcu kamienie na szaniec.
`,
        Kres: `Czas już się rozstać,
rozstania czas…
Już nie ma sensu.
Już nie ma nas!

Czas już się rozstać,
rozstania sens…
Przeszył nas wnet.
I nadszedł kres.

Czas już się rozstać,
nie mówisz nic!
Twoje milczenie jest 
niczym szpic!

Twoje milczenie, jest niczym cierń.
Przeszyty chłodem spleśniały pień!
`,
        Czas: `Rzeźbię dłutem w suchej glinie,
kreślę palcem czasu linie…
Rzeźbię życie, a czas leci.
Nie ma śmiechu, nie ma dzieci.
Nie ma trosk i nie ma smutku.
Sam bez siebie pomalutku,
wchodzę w bezkres po cichutku.
`,
        Autoidentyfikacja: `Nie jestem robotem.
Nie jestem skrojony na miarę.
Nie jestem wartością dodaną.
Nie jestem uszyty według potrzeb.

Czy identyfikacja jest kwestią nadaną?
Kontekstu śladem, czy formą przybraną?

Uwięziony we wszechświecie,
W zakamarkach z jatką.
Bezbronny jak dziecię, 
podporządkowany gadką.

W strukturze mroku, 
mknę z roku do roku,
przez wąwóz ciemności
w powłoce nicości.

Czynił, co czynił,
nikogo nie winił.

Codziennie w bólach trudu śnię,
jak przeżyć każdy kolejny dzień.
`,
        Jestem: `Jestem złożony, mam kilka warstw.
Mam kilka wytchnień, mam wiele spraw.

Mam dużo bólu i mnóstwo trosk
Mam alter ego – ma dzisiaj głos!

Jest jak pergamin lub ciepły wosk
Jak modelina skrada się,
Twardniejąc przy tym gdy tego chcę!

Warstwa za warstwą otwiera mnie,
Gdy jego słowa pojawią się.
Przekraczam progi, wyznaczam je!

Mam alter ego – zrodziło się!
Pragnęło władzy przejęło ster!
Spychając inne w najdalszy cień!

Jestem złożony mam kilka warstw,
Mam kilka wcieleń i zero łask,
W mej głowie wojna, w mej duszy znój,
Szalony wyścig historii rój.

Idąc przez życie poznaje je,
Wychodzą ze mnie i rodzą się
Nadają kształty i kreślą twór,
Stworzony przez nie prywatny wzór.
`,
        Gra: `Komu zapali się czas?

W blasku jasności sięgam po grę,
W odmętach mroku płynę,
Kto dziś przeżyje, a kto nie?
Dla kogo zapłoną chwile?

Czarną lawą płynę przez pustynię,
mijając oczy niczyje, 
a serce chociaż pełne karmazynu barw 
już dawno nie bije…

Odrzucam ciepło, przyjmuję chłód.
zmęczony iskrą życia, 
przebieram w stertach zwierzeń,
i wykopuję czarny rów, 
nadając mu sens bez pokrycia
`,
        Sen: `Sen
Światło w półmroku rozchodzi się, 
po katach drzemie, w pół jawie śnię.
W srebrzystej zbroi do walki brnę,
zapominając czym był ten sen!

W czerwonym świetle latarni blask,
z nadzieją czekam wciąż chwytam brzask.
Żar papierosa rozświetla mrok, 
w czeluści otchłań oddaję skok.

W czerwonych makach na łożu śnię,
czekając kiedy nadejdzie zen.
Czekając kiedy nadejdzie Pan, 
okryty nocą Morfeusz sam.

Dziś błyszczę bardziej i mocniej lśnię, 
zaklinam w boju najgorszy sen.
Zamknięty w pętli wciąż kręcę ster,
w historii wieczność, w umyśle dzień.
`,
        Orgazm: `Ta siła niewiarygodna pojawia się i znika.
Rozbija mnie na cząstki elementarne.

Zewnętrzne wnętrze.

To oddech świeżości, to bryza powietrza.
Wywija mnie jak żagiel na wietrze.

To woń w piwnicy, grzybni spleśniałej.
Wilgotnej mokrej i całej oddanej. 
`,
        Dom: `To szkielet z uczuć zbudowany.
To instalacja trosk i echo myśli poskładanych.
To stół wszelkich rozpaczy i strop nieugiętej miłości.
To wizjer światła, ostoja gości.
To łoże żądz i garderoba ról.
To schody do nieba i przepaść w dół.
To ciepły piec do emocji grzania.
To samotny kąt do cichego łkania.
To niewypowiedziane słowa.
To gra w smutki i radości bezwarunkowa.
`,
        Kataklizm: `W kloszardzkim stylu,
bez prawa do azylu.
Bez prawa do głosu,
szukam rozgłosu.

W kulturze technokracji,
psychopatów racji.
Szukam narracji,
słuszności, owacji.

W queerowej manierze, 
perłowej karierze.
Jeszcze wierzę, już nie stoję,
cicho leżę.

Do gazu od razu.
Do GAZY bez skazy.

Jak kamikadze wystawiam swe twarze,
na medialne i krwawe mamony ołtarze.

W wodnika erze, mniej biorę, mniej szczerze…

Mniej pływam, mniej myślę, mniej wierzę,
mniej pragnę, mniej czuję, mniej jestem.

Jest kataklizm, bo Kata klika.
`,
        Przejście: `Moje ciało płonie, dymią moje usta, 
czarne oczy skwierczą, nie mam tchu już w płucach.

Jak Jim Morrison szukam drzwi,  
Do przejścia bez bólu i użycia sił.

Nie mam już woli tak dłużej żyć,
Bez  egzystencji to marny pic.

Jak czarny karzeł, wessany kleszcz
Wciąż szukam przejścia, by rychło zbiec.

By rychło zniknąć z eteru wszem
Zapomnieć wszystko, co było złe.
`,
        "Aberracja – 2": `
Moja głowa, jak pochodnia gaśnie…
Wizja znika w blasku mroku, myśl powoli w cieniu zaśnie.
I wiem czego pragnie od mej duszy,
Nie ma muru…,mur się skruszył!
Już wiem kiedy skona,
Kiedy się wypali ona,
Kiedy kryształ zmiesza z błotem
I dołoży bólem, cierniem, młotem.
W pył obróci, w znak położy
I przybierze kolor zorzy.
Nie ma już tajemnic żadnych,
Niespokojnych pragnień władnych.
Nie jest męką, jest zwierciadłem,
W mroku chwyta pasma świateł
I prowadzi mnie bezwładnie.
`,
      },
    },
  },

  artworks: {
    "0082": {
      metaTitle: "Pokaż kotku co masz w środku",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, Pokaż kotku co masz w środku",
      artworkId: "0082",
      artworkTitle: "Pokaż kotku co masz w środku",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "50cm",
      artworkDimensionHeight: "50cm",
      artworkCreationDate: "X 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: ``,
      artworkImages: {
        "0082-1": "images/0082/0082-1.jpg",
        "0082-2": "images/0082/0082-2.jpg",
        "0082-3": "images/0082/0082-3.jpg",
        "0082-4": "images/0082/0082-4.jpg",
        "0082-5": "images/0082/0082-5.jpg",
        "0082-6": "images/0082/0082-6.jpg",
        "0082-7": "images/0082/0082-7.jpg",
        "0082-8": "images/0082/0082-8.jpg",
        "0082-9": "images/0082/0082-9.jpg",
        "0082-10": "images/0082/0082-10.jpg",
        "0082-11": "images/0082/0082-11.jpg",
        "0082-12": "images/0082/0082-12.jpg",
        "0082-13": "images/0082/0082-13.jpg",
        "0082-14": "images/0082/0082-14.jpg",
      },
    },

    "0081": {
      metaTitle: "Dreamer",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, Dreamer",
      artworkId: "0081",
      artworkTitle: "Dreamer",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "50cm",
      artworkDimensionHeight: "50cm",
      artworkCreationDate: "XI 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: ``,
      artworkImages: {
        "0081-1": "images/0081/0081-1.jpg",
      },
    },

    "0080": {
      metaTitle: "EGG N°4 5 6",
      metaDescription: "",
      metaKeywords: "Structuralist, EGG DOMINATION, EGG N°4 5 6",
      artworkId: "0080",
      artworkTitle: "EGG N°4 5 6",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "100cm",
      artworkDimensionHeight: "80cm",
      artworkCreationDate: "VIII 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: ``,
      artworkImages: {
        "0080-1": "images/0080/0080-1.jpg",
        "0080-2": "images/0080/0080-2.jpg",
        "0080-3": "images/0080/0080-3.jpg",
        "0080-4": "images/0080/0080-4.jpg",
        "0080-5": "images/0080/0080-5.jpg",
        "0080-6": "images/0080/0080-6.jpg",
        "0080-7": "images/0080/0080-7.jpg",
        "0080-8": "images/0080/0080-8.jpg",
        "0080-9": "images/0080/0080-9.jpg",
        "0080-10": "images/0080/0080-10.jpg",
        "0080-11": "images/0080/0080-11.jpg",
        "0080-12": "images/0080/0080-12.jpg",
        "0080-13": "images/0080/0080-13.jpg",
        "0080-14": "images/0080/0080-14.jpg",
        "0080-15": "images/0080/0080-15.jpg",
        "0080-16": "images/0080/0080-16.jpg",
        "0080-17": "images/0080/0080-17.jpg",
        "0080-18": "images/0080/0080-18.jpg",
      },
    },

    "0079": {
      metaTitle: "EGG N°3",
      metaDescription: "",
      metaKeywords: "Structuralist, EGG DOMINATION, EGG N°3",
      artworkId: "0079",
      artworkTitle: "EGG N°3",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "54cm",
      artworkDimensionHeight: "74cm",
      artworkCreationDate: "IV 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: ``,
      artworkImages: {
        "0079-1": "images/0079/0079-1.jpg",
        "0079-2": "images/0079/0079-2.jpg",
      },
    },

    "0078": {
      metaTitle: "EGG N°2",
      metaDescription: "",
      metaKeywords: "Structuralist, EGG DOMINATION, EGG N°2",
      artworkId: "0078",
      artworkTitle: "EGG N°2",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "50cm",
      artworkDimensionHeight: "70cm",
      artworkCreationDate: "III 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: ``,
      artworkImages: {
        "0078-1": "images/0078/0078-1.jpg",
        "0078-2": "images/0078/0078-2.jpg",
        "0078-3": "images/0078/0078-3.jpg",
        "0078-4": "images/0078/0078-4.jpg",
        "0078-5": "images/0078/0078-5.jpg",
        "0078-6": "images/0078/0078-6.jpg",
        "0078-7": "images/0078/0078-7.jpg",
        "0078-8": "images/0078/0078-8.jpg",
        "0078-9": "images/0078/0078-9.jpg",
        "0078-10": "images/0078/0078-10.jpg",
        "0078-11": "images/0078/0078-11.jpg",
      },
    },

    "0077": {
      metaTitle: "EGG N°1",
      metaDescription: "",
      metaKeywords: "Structuralist, EGG DOMINATION, EGG N°1",
      artworkId: "0077",
      artworkTitle: "EGG N°1",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "60cm",
      artworkDimensionHeight: "80cm",
      artworkCreationDate: "IV 2025",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription: ``,
      artworkImages: {
        "0077-1": "images/0077/0077-1.jpg",
        "0077-2": "images/0077/0077-2.jpg",
        "0077-3": "images/0077/0077-3.jpg",
        "0077-4": "images/0077/0077-4.jpg",
        "0077-5": "images/0077/0077-5.jpg",
        "0077-6": "images/0077/0077-6.jpg",
        "0077-7": "images/0077/0077-7.jpg",
        "0077-8": "images/0077/0077-8.jpg",
        "0077-9": "images/0077/0077-9.jpg",
        "0077-10": "images/0077/0077-10.jpg",
        "0077-11": "images/0077/0077-11.jpg",
      },
    },

    "0076": {
      metaTitle: "NONAGON",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, NONAGON",
      artworkId: "0076",
      artworkTitle: "NONAGON",
      artworkCycle: "RZEŹBA",
      artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "I 2025",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: `
        Nonagon (Nona, 9, dziewięcioramienny)
        9 znaczeń symbolicznych:
        1. Numerologiczne ( matematyczne)
        Cztery boki podstawy dolnej + cztery boki podstawy górnej + punkt wyniesienia pięść ( łącznie 9 punktów skupienia). 9 ramion.
        2. Symboliczne ( transformacyjne)
        Jednym z najstarszych skojarzeń związanych z liczbą 9, jest idea zakończenia jednego cyklu i rozpoczęcia nowego cyklu, w tym kontekście liczba 9 sugeruje, że po okresie zmian i transformacji nadchodzi coś nowego, ekscytującego.
        3. Ewolucyjne
        9 jest często postrzegana jako liczba reprezentującą, rozwój osobisty. Sugeruje, że po doświadczeniach osiągamy wyższy poziom świadomości,  uniesienia, ewolucji. Pozbawiony stereotypów, przyjętych schematów, czy dogmatów.
        4. Magiczne
        Ze względu na swoje głębokie znaczenie symboliczne, liczba 9 była kojarzona z magią. 9 była uważana za liczbę mistyczną, otwierająca drzwi do nieznanych portali.
        5. Metafizyczne
        W mitologii Nordyckiej i innych świat dzieli się na 9 różnych poziomów istnienia, 9 ramion symbolizuje połączenie z różnymi wymiarami rzeczywistości.
        6. Artystyczne
        W odniesieniu do 9 muz z mitologii greckiej, 9 ramion odnosi się do 9 pierwiastków artystycznych.
        7. Konfrontacyjne(duchowe)
        Osadzenie pewnych świętości w ujęciu artystycznym i pozbawienie ich pewnych dogmatów, wymusza spojrzenie na to z INNEgo punktu widzenia i skonfrontowanie pojawiających się przy tym leków z nową zmutowaną, zmodyfikowaną rzeczywistością.
        8. Euforyczne ( zakodowane)
        ciało, umysł, euforia.
        9. Uniesiona ręka z zaciśniętą pięścią = 9`,
      artworkImages: {
        "0076-1": "images/0076/0076-1.jpg",
        "0076-2": "images/0076/0076-2.jpg",
        "0076-3": "images/0076/0076-3.jpg",
        "0076-4": "images/0076/0076-4.jpg",
        "0076-5": "images/0076/0076-5.jpg",
        "0076-6": "images/0076/0076-6.jpg",
        "0076-7": "images/0076/0076-7.jpg",
        "0076-8": "images/0076/0076-8.jpg",
        "0076-9": "images/0076/0076-9.jpg",
        "0076-10": "images/0076/0076-10.jpg",
        "0076-11": "images/0076/0076-11.jpg",
        "0076-12": "images/0076/0076-12.jpg",
        "0076-13": "images/0076/0076-13.jpg",
        "0076-14": "images/0076/0076-14.jpg",
      },
    },

    "0075": {
      metaTitle: "LITHOPS ANUS",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, LITHOPS ANUS",
      artworkId: "0075",
      artworkTitle: "LITHOPS ANUS",
      artworkCycle: "RZEŹBA",
      artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "II 2025",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Wszyscy jesteśmy jednością. Świat i wszystkie istoty żywe składają się z takich samych pierwiastków, atomów, mikrocząstek, tylko znajdują sobie swój własny punkt skupienia. Nie tylko na poziomie atomów i cząstek jesteśmy jednością, ale również nasze ciała i byty mogą mieć fizyczne podobieństwa, nawet jeśli pochodzimy z różnych gatunków czy form istnienia. To sugeruje, że granice między organizmami są bardziej umowne, niż nam się wydaje i czyni nas wszystkie istoty ziemskie równymi sobie.",
      artworkImages: {
        "0075-1": "images/0075/0075-1.jpg",
        "0075-2": "images/0075/0075-2.jpg",
        "0075-3": "images/0075/0075-3.jpg",
        "0075-4": "images/0075/0075-4.jpg",
        "0075-5": "images/0075/0075-5.jpg",
        "0075-6": "images/0075/0075-6.jpg",
        "0075-7": "images/0075/0075-7.jpg",
        "0075-8": "images/0075/0075-8.jpg",
        "0075-9": "images/0075/0075-9.jpg",
        "0075-10": "images/0075/0075-10.jpg",
        "0075-11": "images/0075/0075-11.jpg",
        "0075-12": "images/0075/0075-12.jpg",
        "0075-13": "images/0075/0075-13.jpg",
        "0075-14": "images/0075/0075-14.jpg",
        "0075-15": "images/0075/0075-15.jpg",
        "0075-16": "images/0075/0075-16.jpg",
        "0075-17": "images/0075/0075-17.jpg",
        "0075-18": "images/0075/0075-18.jpg",
        "0075-19": "images/0075/0075-19.jpg",
        "0075-20": "images/0075/0075-20.jpg",
        "0075-21": "images/0075/0075-21.jpg",
      },
    },

    "0074": {
      metaTitle: "EGG N°0",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, EGG N°0",
      artworkId: "0074",
      artworkTitle: "EGG N°0",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "32 cm",
      artworkDimensionHeight: "37 cm",
      artworkCreationDate: "X 2024",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription: "",
      artworkImages: {
        "0074-1": "images/0074/0074-1.jpg",
        "0074-2": "images/0074/0074-2.jpg",
        "0074-3": "images/0074/0074-3.jpg",
        "0074-4": "images/0074/0074-4.jpg",
        "0074-5": "images/0074/0074-5.jpg",
        "0074-6": "images/0074/0074-6.jpg",
        "0074-7": "images/0074/0074-7.jpg",
      },
    },

    "0073": {
      metaTitle: "INDIAN SUMMER",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, INDIAN SUMMER",
      artworkId: "0073",
      artworkTitle: "INDIAN SUMMER",
      artworkCycle: "INNE",
      artworkWidth: "1",
      artworkDimensionWidth: "50 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "IX 2024",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "",
      artworkImages: {
        "0073-1": "images/0073/0073-1.jpg",
        "0073-2": "images/0073/0073-2.jpg",
        "0073-3": "images/0073/0073-3.jpg",
        "0073-4": "images/0073/0073-4.jpg",
        "0073-5": "images/0073/0073-5.jpg",
        "0073-6": "images/0073/0073-6.jpg",
        "0073-7": "images/0073/0073-7.jpg",
      },
    },

    "0072": {
      metaTitle: "BREATH OF SUMMER",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BREATH OF SUMMER",
      artworkId: "0072",
      artworkTitle: "BREATH OF SUMMER",
      artworkCycle: "INNE",
      artworkWidth: "1",
      artworkDimensionWidth: "50 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "X 2022",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "Odciski roślin na płótnie.",
      artworkImages: {
        "0072-1": "images/0072/0072-1.jpg",
        "0072-2": "images/0072/0072-2.jpg",
        "0072-3": "images/0072/0072-3.jpg",
        "0072-4": "images/0072/0072-4.jpg",
        "0072-5": "images/0072/0072-5.jpg",
      },
    },

    "0071": {
      metaTitle: "HERBARIUM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, HERBARIUM",
      artworkId: "0071",
      artworkTitle: "HERBARIUM",
      artworkCycle: "INNE",
      artworkWidth: "1",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "80 cm",
      artworkCreationDate: "VII 2022",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "Odciski roślin na płótnie.",
      artworkImages: {
        "0071-1": "images/0071/0071-1.jpg",
        "0071-2": "images/0071/0071-2.jpg",
        "0071-3": "images/0071/0071-3.jpg",
        "0071-4": "images/0071/0071-4.jpg",
        "0071-5": "images/0071/0071-5.jpg",
      },
    },

    "0070": {
      metaTitle: "COCOONS",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, COCOONS",
      artworkId: "0070",
      artworkTitle: "COCOONS",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "2",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "80 cm",
      artworkCreationDate: "2021",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Obraz ukazuje twór przypominający kokony, stworzony przez organizmy nieznanego pochodzenia. Przestrzeń, która stanowi niezdobytą twierdzę, uchyla rąbki tajemnicy, z czym mamy do czynienia, iż najbardziej fascynujące jest to, co nieznane. Praca powstała na płótnie, przy użyciu wielu warstw czarnej smolistej farby. Pokazuje on, że dom jako przestrzeń jest umowna, a jej symbolu nadaje zamieszkały przez nią organizm.",
      artworkImages: {
        "0070-1": "images/0070/0070-1.jpg",
        "0070-2": "images/0070/0070-2.jpg",
        "0070-3": "images/0070/0070-3.jpg",
        "0070-4": "images/0070/0070-4.jpg",
        "0070-5": "images/0070/0070-5.jpg",
        "0070-6": "images/0070/0070-6.jpg",
      },
    },

    "0069": {
      metaTitle: "BRAINBLOOM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BRAINBLOOM",
      artworkId: "0069",
      artworkTitle: "BRAINBLOOM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Brainbloom jest to nawiązanie do jego poprzednika Brainboom. Tylko tym razem nie jest to wybuch inteligencji i expresji. Oznacza to dominację sił natury nad człowiekiem. Człowiek powinien żyć w zgodzie z natura, gdyż z niej wprost wyrasta  jest jej owocem i kwiatem.",
      artworkImages: {
        "0069-1": "images/0069/0069-1.jpg",
        "0069-2": "images/0069/0069-2.jpg",
        "0069-3": "images/0069/0069-3.jpg",
        "0069-4": "images/0069/0069-4.jpg",
        "0069-5": "images/0069/0069-5.jpg",
        "0069-6": "images/0069/0069-6.jpg",
        "0069-7": "images/0069/0069-7.jpg",
      },
    },

    "0068": {
      metaTitle: "QUANTUM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, QUANTUM",
      artworkId: "0068",
      artworkTitle: "QUANTUM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "80 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "Akryl, olej na płótnie.",
      artworkImages: {
        "0068-1": "images/0068/0068-1.jpg",
        "0068-2": "images/0068/0068-2.jpg",
        "0068-3": "images/0068/0068-3.jpg",
        "0068-4": "images/0068/0068-4.jpg",
      },
    },

    "0067": {
      metaTitle: "PULSE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, PULSE",
      artworkId: "0067",
      artworkTitle: "PULSE",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "80 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "Akryl, spray.",
      artworkImages: {
        "0067-1": "images/0067/0067-1.jpg",
        "0067-2": "images/0067/0067-2.jpg",
        "0067-3": "images/0067/0067-3.jpg",
        "0067-4": "images/0067/0067-4.jpg",
      },
    },

    /*"0066": {
      metaTitle: "Pomarańcza",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, Pomarańcza",
      artworkId: "0066",
      artworkTitle: "Pomarańcza",
      artworkCycle: "STRUCTURAL COLLAGE",artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        'Ikea lampa wisząca - REGOLIT Klosz zwis HEMMA. Modyfikacja autorska: pomarańczowy spray KOBRA, papier, klej.\n"POMARAŃCZA"',
      artworkImages: {
        "0066-1": "images/0066/0066-1.jpg",
        "0066-2": "images/0066/0066-2.jpg",
        "0066-3": "images/0066/0066-3.jpg",
        "0066-4": "images/0066/0066-4.jpg",
      },
    },*/

    "0065": {
      metaTitle: "SHADE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, SHADE",
      artworkId: "0065",
      artworkTitle: "SHADE",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "2020",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        'Projekt a może po prostu lampa.\nWykonana z metalu oraz plastikowej czarnej siatki. Stworzona na podstawie i trzonie przekształconej lampy papierowej z @ikeawnetrza "STORM". Na lampie zamontowano żarówki.',
      artworkImages: {
        "0065-1": "images/0065/0065-1.jpg",
        "0065-2": "images/0065/0065-2.jpg",
        "0065-3": "images/0065/0065-3.jpg",
        "0065-4": "images/0065/0065-4.jpg",
      },
    },

    "0064": {
      metaTitle: "EXTASY KISS",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, EXTASY KISS",
      artworkId: "0064",
      artworkTitle: "EXTASY KISS",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        'Praca powstała w wyniku inspiracji zdjęciem pracy belgijskiego artysty Wim Deloye pod tytułem "Kiss" Z 2001 roku. Akryl na płótnie, spray.',
      artworkImages: {
        "0064-1": "images/0064/0064-1.jpg",
      },
    },

    "0063": {
      metaTitle: "TRIGGER",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, TRIGGER",
      artworkId: "0063",
      artworkTitle: "TRIGGER",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Obraz wykonany na płótnie 3d. Na konstrukcję składa się cienka siatka plastikowa, nakładana w kilku warstwach oraz przyklejona za pomocą specjalistycznego kleju do płótna oraz farba. Boki pomalowane obraz nie wymaga ramy. Nawiązuje do angielskiego słowa trigger , które oznacza wyzwalacz.",
      artworkImages: {
        "0063-1": "images/0063/0063-1.jpg",
        "0063-2": "images/0063/0063-2.jpg",
        "0063-3": "images/0063/0063-3.jpg",
        "0063-4": "images/0063/0063-4.jpg",
        "0063-5": "images/0063/0063-5.jpg",
        "0063-6": "images/0063/0063-6.jpg",
        "0063-7": "images/0063/0063-7.jpg",
        "0063-8": "images/0063/0063-8.jpg",
        "0063-9": "images/0063/0063-9.jpg",
      },
    },

    "0062": {
      metaTitle: "TOXIC",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, TOXIC",
      artworkId: "0062",
      artworkTitle: "TOXIC",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2020",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca symbolizuje „coś” toksycznego, trującego, substancję która budzi niepokój, zielony trujący gaz i jest czymś nieznanym, dzikim i nieodkrytym. Powoli wydobywa się na powierzchnię by opanować cały świat. Praca powstała pod wpływem narastającej epidemii COVID-19.",
      artworkImages: {
        "0062-1": "images/0062/0062-1.jpg",
        "0062-2": "images/0062/0062-2.jpg",
        "0062-3": "images/0062/0062-3.jpg",
        "0062-4": "images/0062/0062-4.jpg",
        "0062-5": "images/0062/0062-5.jpg",
        "0062-6": "images/0062/0062-6.jpg",
        "0062-7": "images/0062/0062-7.jpg",
        "0062-8": "images/0062/0062-8.jpg",
      },
    },

    "0061": {
      metaTitle: "HIVÉ",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, HIVÉ",
      artworkId: "0061",
      artworkTitle: "HIVÉ",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca wykonana w charakterze STRUCTURAL COLLAGE. Do jej wykonania posłużyła czarna plastikowa siatka przytwierdzona do płótna za pomocą specjalistycznego kleju zalana czarną olejną farbą. Symbolizuje, ul, społeczeństwo.",
      artworkImages: {
        "0061-1": "images/0061/0061-1.jpg",
        "0061-2": "images/0061/0061-2.jpg",
        "0061-3": "images/0061/0061-3.jpg",
        "0061-4": "images/0061/0061-4.jpg",
        "0061-5": "images/0061/0061-5.jpg",
        "0061-6": "images/0061/0061-6.jpg",
        "0061-7": "images/0061/0061-7.jpg",
        "0061-8": "images/0061/0061-8.jpg",
        "0061-9": "images/0061/0061-9.jpg",
      },
    },

    "0060": {
      metaTitle: "FREEDOM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, FREEDOM",
      artworkId: "0060",
      artworkTitle: "FREEDOM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Freedom: oznacza wolność artystyczną. Wolność poprzez zastosowanie różnych technik malarskich. Wolność w postaci abstrakcji artystycznej. Wolność w postaci otwartego umysłu na nowe. Wykonany z opiłków metalu przytwierdzonych za pomocą specjalistycznego kleju i grubo lanej farby. Obraz zamalowany po bokach nie wymaga ramy, sygnowany i podpisany na odwrocie.",
      artworkImages: {
        "0060-1": "images/0060/0060-1.jpg",
        "0060-2": "images/0060/0060-2.jpg",
        "0060-3": "images/0060/0060-3.jpg",
        "0060-4": "images/0060/0060-4.jpg",
        "0060-5": "images/0060/0060-5.jpg",
        "0060-6": "images/0060/0060-6.jpg",
        "0060-7": "images/0060/0060-7.jpg",
        "0060-8": "images/0060/0060-8.jpg",
        "0060-9": "images/0060/0060-9.jpg",
      },
    },

    "0059": {
      metaTitle: "PINK TEETH",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, PINK TEETH",
      artworkId: "0059",
      artworkTitle: "PINK TEETH",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "50 cm",
      artworkDimensionHeight: "70 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca z cyklu INTERIOR nawiązująca do zdjęcia rentgenowskiego oraz wystawy INTERIOR.",
      artworkImages: {
        "0059-1": "images/0059/0059-1.jpg",
      },
    },

    "0058": {
      metaTitle: "GREEN TEETH",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, GREEN TEETH",
      artworkId: "0058",
      artworkTitle: "GREEN TEETH",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "120 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca z cyklu INTERIOR nawiązująca do zdjęcia rentgenowskiego oraz wystawy INTERIOR.",
      artworkImages: {
        "0058-1": "images/0058/0058-1.jpg",
      },
    },

    "0057": {
      metaTitle: "BLUE TEETH",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, BLUE TEETH",
      artworkId: "0057",
      artworkTitle: "BLUE TEETH",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "50 cm",
      artworkDimensionHeight: "70 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca z cyklu INTERIOR nawiązująca do zdjęcia rentgenowskiego oraz wystawy INTERIOR.",
      artworkImages: {
        "0057-1": "images/0057/0057-1.jpg",
      },
    },
    /*
    "0056": {
      metaTitle: "Dragon Flower",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, Dragon Flower",
      artworkId: "0056",
      artworkTitle: "Dragon Flower",
      artworkCycle: "STRUCTURAL COLLAGE",artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "50 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Instalacja artystyczna wykonana z papieru. Imitującą liście roślINNE, przypominające jednocześnie smocze skrzydła i roślinę egzotyczną.",
      artworkImages: {
        "0056-1": "images/0056/0056-1.jpg",
        "0056-2": "images/0056/0056-2.jpg",
        "0056-3": "images/0056/0056-3.jpg",
        "0056-4": "images/0056/0056-4.jpg",
        "0056-5": "images/0056/0056-5.jpg",
      },
    },
*/
    "0055": {
      metaTitle: "SPACE BRAIN",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SPACE BRAIN",
      artworkId: "0055",
      artworkTitle: "SPACE BRAIN",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca powstała w nawiązaniu do zdjęcia z rezonansu magnetycznego. Ukazując abstrakcyjnamą wizję mózgu. Będąc odniesieniem do cyklu INTERIOR lecz z wykorzystaniem rezonansu magnetycznego.",
      artworkImages: {
        "0055-1": "images/0055/0055-1.jpg",
        "0055-2": "images/0055/0055-2.jpg",
      },
    },

    "0054": {
      metaTitle: "SECRET BRAIN",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SECRET BRAIN",
      artworkId: "0054",
      artworkTitle: "SECRET BRAIN",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca powstała w nawiązaniu do zdjęcia z rezonansu magnetycznego. Ukazując abstrakcyjnamą wizję mózgu. Będąc odniesieniem do cyklu INTERIOR lecz z wykorzystaniem rezonansu magnetycznego.",
      artworkImages: {
        "0054-1": "images/0054/0054-1.jpg",
        "0054-2": "images/0054/0054-2.jpg",
      },
    },

    "0053": {
      metaTitle: "GOLDEN BRAIN",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, GOLDEN BRAIN",
      artworkId: "0053",
      artworkTitle: "GOLDEN BRAIN",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca powstała w nawiązaniu do zdjęcia z rezonansu magnetycznego. Ukazując abstrakcyjnamą wizję mózgu. Będąc odniesieniem do cyklu INTERIOR lecz z wykorzystaniem rezonansu magnetycznego.",
      artworkImages: {
        "0053-1": "images/0053/0053-1.jpg",
        "0053-2": "images/0053/0053-2.jpg",
      },
    },

    "0052": {
      metaTitle: "SUPER BRAIN",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SUPER BRAIN",
      artworkId: "0052",
      artworkTitle: "SUPER BRAIN",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca powstała w nawiązaniu do zdjęcia z rezonansu magnetycznego. Ukazując abstrakcyjnamą wizję mózgu. Będąc odniesieniem do cyklu INTERIOR lecz z wykorzystaniem rezonansu magnetycznego.",
      artworkImages: {
        "0052-1": "images/0052/0052-1.jpg",
        "0052-2": "images/0052/0052-2.jpg",
      },
    },

    "0051": {
      metaTitle: "ALIEN",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, ALIEN",
      artworkId: "0051",
      artworkTitle: "ALIEN",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca powstała inspirując się zdjęciem powstałym podczas badania rezonansem magnetycznym. W nawiązaniu do obcych.",
      artworkImages: {
        "0051-1": "images/0051/0051-1.jpg",
        "0051-2": "images/0051/0051-2.jpg",
      },
    },

    "0050": {
      metaTitle: "ALARM",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, ALARM",
      artworkId: "0050",
      artworkTitle: "ALARM",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca powstała inspirując się zdjęciem powstałym podczas badania rezonansem magnetycznym. W nawiązaniu do obcych.",
      artworkImages: {
        "0050-1": "images/0050/0050-1.jpg",
        "0050-2": "images/0050/0050-2.jpg",
      },
    },

    "0049": {
      metaTitle: "INTERIOR DOG 1 / INTERIOR DOG 2",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, INTERIOR DOG 1 / INTERIOR DOG 2",
      artworkId: "0049",
      artworkTitle: "INTERIOR DOG 1 / INTERIOR DOG 2",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "2 x 70 cm",
      artworkDimensionHeight: "2 x 50 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Prace powstałe w wyniku inspiracji cyklem INTERIOR nawiązując do zdjęcia rentgenowskiego psa.",
      artworkImages: {
        "0049-1": "images/0049/0049-1.jpg",
        "0049-2": "images/0049/0049-2.jpg",
        "0049-3": "images/0049/0049-3.jpg",
        "0049-4": "images/0049/0049-4.jpg",
      },
    },

    "0048": {
      metaTitle: "PINKTERIOR",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, PINKTERIOR",
      artworkId: "0048",
      artworkTitle: "PINKTERIOR",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0048-1": "images/0048/0048-1.jpg",
      },
    },

    "0047": {
      metaTitle: "LEMON BROTHER SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, LEMON BROTHER SKULL",
      artworkId: "0047",
      artworkTitle: "LEMON BROTHER SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0047-1": "images/0047/0047-1.jpg",
      },
    },

    "0046": {
      metaTitle: "RAINBOW SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, RAINBOW SKULL",
      artworkId: "0046",
      artworkTitle: "RAINBOW SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0046-1": "images/0046/0046-1.jpg",
      },
    },

    "0045": {
      metaTitle: "FIRE SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, FIRE SKULL",
      artworkId: "0045",
      artworkTitle: "FIRE SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0045-1": "images/0045/0045-1.jpg",
      },
    },

    "0044": {
      metaTitle: "DISCO SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, DISCO SKULL",
      artworkId: "0044",
      artworkTitle: "DISCO SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0044-1": "images/0044/0044-1.jpg",
      },
    },

    "0043": {
      metaTitle: "EARTH SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, EARTH SKULL",
      artworkId: "0043",
      artworkTitle: "EARTH SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0043-1": "images/0043/0043-1.jpg",
      },
    },

    "0042": {
      metaTitle: "COPPER SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, COPPER SKULL",
      artworkId: "0042",
      artworkTitle: "COPPER SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0042-1": "images/0042/0042-1.jpg",
      },
    },

    "0041": {
      metaTitle: "GOLDEN SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, GOLDEN SKULL",
      artworkId: "0041",
      artworkTitle: "GOLDEN SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0041-1": "images/0041/0041-1.jpg",
      },
    },

    "0040": {
      metaTitle: "HARPER SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, HARPER SKULL",
      artworkId: "0040",
      artworkTitle: "HARPER SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0040-1": "images/0040/0040-1.jpg",
      },
    },

    "0039": {
      metaTitle: "SHOOT SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SHOOT SKULL",
      artworkId: "0039",
      artworkTitle: "SHOOT SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0039-1": "images/0039/0039-1.jpg",
      },
    },

    "0038": {
      metaTitle: "BLOODY SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, BLOODY SKULL",
      artworkId: "0038",
      artworkTitle: "BLOODY SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0038-1": "images/0038/0038-1.jpg",
      },
    },

    "0037": {
      metaTitle: "PINK BULLLET SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, PINK BULLLET SKULL",
      artworkId: "0037",
      artworkTitle: "PINK BULLLET SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "29,7 cm",
      artworkDimensionHeight: "42 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0037-1": "images/0037/0037-1.jpg",
      },
    },

    "0036": {
      metaTitle: "PINK FLOW",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, PINK FLOW",
      artworkId: "0036",
      artworkTitle: "PINK FLOW",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0036-1": "images/0036/0036-1.jpg",
      },
    },

    "0035": {
      metaTitle: "INDIA SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, INDIA SKULL",
      artworkId: "0035",
      artworkTitle: "INDIA SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0035-1": "images/0035/0035-1.jpg",
      },
    },

    "0034": {
      metaTitle: "CLOWN SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, CLOWN SKULL",
      artworkId: "0034",
      artworkTitle: "CLOWN SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0034-1": "images/0034/0034-1.jpg",
      },
    },

    "0033": {
      metaTitle: "SOLAR SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SOLAR SKULL",
      artworkId: "0033",
      artworkTitle: "SOLAR SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0033-1": "images/0033/0033-1.jpg",
      },
    },

    "0032": {
      metaTitle: "VOLATILE SKULL",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, VOLATILE SKULL",
      artworkId: "0032",
      artworkTitle: "VOLATILE SKULL",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        'Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR. Druga część dyptyku z serii "Volatile".',
      artworkImages: {
        "0032-1": "images/0032/0032-1.jpg",
      },
    },

    "0031": {
      metaTitle: "VOLATILE",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, VOLATILE",
      artworkId: "0031",
      artworkTitle: "VOLATILE",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR.",
      artworkImages: {
        "0031-1": "images/0031/0031-1.jpg",
        "0031-2": "images/0031/0031-2.jpg",
      },
    },

    "0030": {
      metaTitle: "WINGS",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, WINGS",
      artworkId: "0030",
      artworkTitle: "WINGS",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "50 cm",
      artworkDimensionHeight: "50 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR. Zainspirowany anielskimi skrzydłami.",
      artworkImages: {
        "0030-1": "images/0030/0030-1.jpg",
      },
    },

    "0029": {
      metaTitle: "DRAGONFLY",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, DRAGONFLY",
      artworkId: "0029",
      artworkTitle: "DRAGONFLY",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR. Zainspirowany owadem ważką oraz pokazem Aleksandra McQueena  Plato's Atlantis.",
      artworkImages: {
        "0029-1": "images/0029/0029-1.jpg",
      },
    },

    "0028": {
      metaTitle: "GALACTUS",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, GALACTUS",
      artworkId: "0028",
      artworkTitle: "GALACTUS",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "42 cm",
      artworkDimensionHeight: "59,4 cm",
      artworkCreationDate: "2019",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca zainspirowana zdjęciem rentgenowskim wykonana akrylem na papierze w nawiązaniu do wystawy i cyklu INTERIOR. Zainspirowany zdjęciem kosmosu.",
      artworkImages: {
        "0028-1": "images/0028/0028-1.jpg",
      },
    },

    "0027": {
      metaTitle: "ABLETON",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, ABLETON",
      artworkId: "0027",
      artworkTitle: "ABLETON",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "101 cm",
      artworkDimensionHeight: "134 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Ableton jest pracą wykonaną na wystawę INTERIOR. Za inspirację do wykonania pracy posłużyło zdjęcie rentgenowskie czaszki, które stało się abstrakcyjną wariacją oryginału. Ableton to pewnego rodzaju sprzęt muzyczny, oprogramowanie,  wykorzystywane w muzyce elektronicznej, techno do mixowania dźwięków. Praca jest pewnego rodzaju hołdem dla muzyki techno, poniekąd jak cała wystawa Interio. Praca zalaminowana przez odpowiednie oświetlenie uzyskuje wymiar trójwymiarowy.",
      artworkImages: {
        "0027-1": "images/0027/0027-1.jpg",
        "0027-2": "images/0027/0027-2.jpg",
      },
    },

    "0026": {
      metaTitle: "WONDERLAND",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, WONDERLAND",
      artworkId: "0026",
      artworkTitle: "WONDERLAND",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "101 cm",
      artworkDimensionHeight: "107 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca Wonderland jest wykonana również na wystawę INTERIOR. Zainspirowana jest główną pracą i zdjęciem plakatowym, będącym motywem przewodnim wystawy. Symbolizuje cudowny, magiczny, życzeniowy świat. Jest zalaminowana, co przy odpowiednim oświetleniu daje efekt trójwymiarowości.",
      artworkImages: {
        "0026-1": "images/0026/0026-1.jpg",
      },
    },

    "0025": {
      metaTitle: "SMOQ",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SMOQ",
      artworkId: "0025",
      artworkTitle: "SMOQ",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        'Praca powstała specjalnie na wystawę INTERIOR. Słowo smoq to gra słów można ją interpretować jako: "Smoq" mistyczne zwierzę przedstawione z lotu ptaka. "Smoq" zielony dym  którym niejednokrotnie ludzkość  wypełniała swoje płuca. Projekt zainspirowany zdjęciem rentgenowskim płuc. Zalaminowany, odpowiednio oświetlony sprawia wrażenie lekko trójwymiarowego.',
      artworkImages: {
        "0025-1": "images/0025/0025-1.jpg",
        "0025-2": "images/0025/0025-2.jpg",
      },
    },

    "0024": {
      metaTitle: "DNA",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, DNA",
      artworkId: "0024",
      artworkTitle: "DNA",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "200 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Instalacja artystyczna pod tytułem DNA. Nawiązującą swoim charakterem do cyklu INTERIOR. Stanowiąca metaforyczne odniesienie do dna czyli symbolicznego kodu w którym wszystko jest zapisane.",
      artworkImages: {
        "0024-1": "images/0024/0024-1.jpg",
        "0024-2": "images/0024/0024-2.jpg",
        "0024-3": "images/0024/0024-3.jpg",
        "0024-4": "images/0024/0024-4.jpg",
        "0024-5": "images/0024/0024-5.jpg",
        "0024-6": "images/0024/0024-6.jpg",
        "0024-7": "images/0024/0024-7.jpg",
        "0024-8": "images/0024/0024-8.jpg",
        "0024-9": "images/0024/0024-9.jpg",
      },
    },

    "0023": {
      metaTitle: "SKULLS",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, SKULLS",
      artworkId: "0023",
      artworkTitle: "SKULLS",
      artworkCycle: "INTERIOR",
      artworkWidth: "2",
      artworkDimensionWidth: "29,7 cm",
      artworkDimensionHeight: "42 cm",
      artworkCreationDate: "2017",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Czaszki to projekt zainspirowany zdjęciem rentgenowskim, otrzymanym po prześwietleniu głowy. Maszyna do wykonywania rentgena stała się kolejnym sprzętem, który mogłem przełożyć na działania artystyczne, tym samym dołączając do ją do grona, wtryskarek, skrawarek, tokarek. Otworzyło to także nowy rozdział w zainteresowaniach artystycznych - popartem i zapoczątkowało cykl INTERIOR. Zdjęcie autobiograficzne.",
      artworkImages: {
        "0023-1": "images/0023/0023-1.jpg",
        "0023-2": "images/0023/0023-2.jpg",
        "0023-3": "images/0023/0023-3.jpg",
        "0023-4": "images/0023/0023-4.jpg",
        "0023-5": "images/0023/0023-5.jpg",
        "0023-6": "images/0023/0023-6.jpg",
        "0023-7": "images/0023/0023-7.jpg",
        "0023-8": "images/0023/0023-8.jpg",
        "0023-9": "images/0023/0023-9.jpg",
        "0023-10": "images/0023/0023-10.jpg",
      },
    },

    "0022": {
      metaTitle: "INTERIOR",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, INTERIOR",
      artworkId: "0022",
      artworkTitle: "INTERIOR",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription: "Praca z cyklu „INTERIOR”.",
      artworkImages: {
        "0022-1": "images/0022/0022-1.jpg",
        "0022-2": "images/0022/0022-2.jpg",
        "0022-3": "images/0022/0022-3.jpg",
        "0022-4": "images/0022/0022-4.jpg",
        "0022-5": "images/0022/0022-5.jpg",
        "0022-6": "images/0022/0022-6.jpg",
        "0022-7": "images/0022/0022-7.jpg",
        "0022-8": "images/0022/0022-8.jpg",
        "0022-9": "images/0022/0022-9.jpg",
        "0022-10": "images/0022/0022-10.jpg",
        "0022-11": "images/0022/0022-11.jpg",
        "0022-12": "images/0022/0022-12.jpg",
        "0022-13": "images/0022/0022-13.jpg",
        "0022-14": "images/0022/0022-14.jpg",
        "0022-15": "images/0022/0022-15.jpg",
        "0022-16": "images/0022/0022-16.jpg",
        "0022-17": "images/0022/0022-17.jpg",
        "0022-18": "images/0022/0022-18.jpg",
        "0022-19": "images/0022/0022-19.jpg",
        "0022-20": "images/0022/0022-20.jpg",
        "0022-21": "images/0022/0022-21.jpg",
        "0022-22": "images/0022/0022-22.jpg",
        "0022-23": "images/0022/0022-23.jpg",
        "0022-24": "images/0022/0022-24.jpg",
        "0022-25": "images/0022/0022-25.jpg",
      },
    },

    "0021": {
      metaTitle: "EGGISTANCE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, EGGISTANCE",
      artworkId: "0021",
      artworkTitle: "EGGISTANCE",
      artworkCycle: "EGG DOMINATION",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Obraz wykonany techniką kolażu z wykorzystaniem opiłków metalu, płótna i farby olejnej. Opiłki metalu przytwierdzone za pośrednictwem specjalistycznego kleju. Pracę charakteryzują różnorodne struktury farby Abstrakcyjne ujęcie jaja, bytu biologicznego oraz abstrakcji, która w nim zachodzi. Obraz podpisany zamalowany po bokach nie wymaga ramy.",
      artworkImages: {
        "0021-1": "images/0021/0021-1.jpg",
        "0021-2": "images/0021/0021-2.jpg",
        "0021-3": "images/0021/0021-3.jpg",
        "0021-4": "images/0021/0021-4.jpg",
        "0021-5": "images/0021/0021-5.jpg",
        "0021-6": "images/0021/0021-6.jpg",
        "0021-7": "images/0021/0021-7.jpg",
        "0021-8": "images/0021/0021-8.jpg",
        "0021-9": "images/0021/0021-9.jpg",
      },
    },

    "0020": {
      metaTitle: "MONSTRANCE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, MONSTRANCE",
      artworkId: "0020",
      artworkTitle: "MONSTRANCE",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Obraz fakturowy wykonany techniką kolażu z wykorzystaniem opiłków metalu, płótna i farby olejnej. Opiłki metalu pochodzą z procesu skrawania ze skrawarki i przytwierdzone są do płótna za pomocą specjalistycznego kleju. Użyto farby olejnej oraz werniksu zabezpieczającego. Boki obrazu są pomalowane więc obraz nadaje się do powieszenia i nie wymaga ramy. Obraz jest matowy z błyszczącymi elementami. Praca jest sygnowana i podpisana na odwrocie. Abstrakcyjne ujęcie przedmiotu  wykorzystywanego w Kościele jakim jest Monstrancja, który pomimo blasku pozostaje ciemny i pełen cieni w środku. Fotografia robiona z lampą błyskową.",
      artworkImages: {
        "0020-1": "images/0020/0020-1.jpg",
        "0020-2": "images/0020/0020-2.jpg",
        "0020-3": "images/0020/0020-3.jpg",
        "0020-4": "images/0020/0020-4.jpg",
        "0020-5": "images/0020/0020-5.jpg",
        "0020-6": "images/0020/0020-6.jpg",
        "0020-7": "images/0020/0020-7.jpg",
        "0020-8": "images/0020/0020-8.jpg",
      },
    },

    "0019": {
      metaTitle: "BLACK HONEY",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BLACK HONEY",
      artworkId: "0019",
      artworkTitle: "BLACK HONEY",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2017",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca wykonana techniką mieszaną, z wykorzystaniem farby olejnej, papieru oraz płótna. Obraz abstrakcyjny stanowi kolaż bądź asamblaż stworzony z różnych elementów. Nawiązuje do plastra miodu ukazanego w symbolicznym, mrocznym, apokaliptycznym, ujęciu, będącym jednocześnie przestrogą braku poszanowania życia z naturą jak i abstrakcyjną wariacją na temat struktury plastra miodu. Praca jest sygnowana na odwrocie, boki ma częściowo zamalowane i nie wymaga ramy, zawerniksowana.",
      artworkImages: {
        "0019-1": "images/0019/0019-1.jpg",
        "0019-2": "images/0019/0019-2.jpg",
        "0019-3": "images/0019/0019-3.jpg",
        "0019-4": "images/0019/0019-4.jpg",
        "0019-5": "images/0019/0019-5.jpg",
        "0019-6": "images/0019/0019-6.jpg",
        "0019-7": "images/0019/0019-7.jpg",
        "0019-8": "images/0019/0019-8.jpg",
      },
    },

    "0018": {
      metaTitle: "NET",
      metaDescription: "",
      metaKeywords: "Structuralist, INTERIOR, NET",
      artworkId: "0018",
      artworkTitle: "NET",
      artworkCycle: "INTERIOR",
      artworkWidth: "1",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "200 cm",
      artworkCreationDate: "2018",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Instalacja artystyczna pod tytułem Sieć. Składająca się z pomalowanych pojedynczych zdjęć rentgenowskich łącznie stanowiących całość. Praca będąca metaforą doznań, przeżyć, uczuć, muzycznych, wizualnych, erotycznych stanowiących wewnętrzny INTERIOR nas samych.",
      artworkImages: {
        "0018-1": "images/0018/0018-1.jpg",
        "0018-2": "images/0018/0018-2.jpg",
        "0018-3": "images/0018/0018-3.jpg",
      },
    },

    "0017": {
      metaTitle: "SOURCE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, SOURCE",
      artworkId: "0017",
      artworkTitle: "SOURCE",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2017",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Obraz fakturowy wykonany z opiłków metalu pochodzących ze skrawarki z procesu skrawania, grubo lanej czarnej farby olejnej oraz farb olejnych sztalugowych. Czarny element pracy jest nawiązaniem z do mistycznego źródła, otchłani, przejścia. Jest tez pewnym symbolem niepokoju łączącego wszystkie obrazy, w których czarny element występuje. Podpisany na odwrocie.",
      artworkImages: {
        "0017-1": "images/0017/0017-1.jpg",
        "0017-2": "images/0017/0017-2.jpg",
        "0017-3": "images/0017/0017-3.jpg",
        "0017-4": "images/0017/0017-4.jpg",
        "0017-5": "images/0017/0017-5.jpg",
        "0017-6": "images/0017/0017-6.jpg",
        "0017-7": "images/0017/0017-7.jpg",
        "0017-8": "images/0017/0017-8.jpg",
        "0017-9": "images/0017/0017-9.jpg",
        "0017-10": "images/0017/0017-10.jpg",
      },
    },
    /*
    "0016": {
      metaTitle: "Filtry",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, Filtry",
      artworkId: "0016",
      artworkTitle: "Filtry ",
      artworkCycle: "STRUCTURAL COLLAGE",artworkWidth: "1",
      artworkDimensionWidth: "21 cm",
      artworkDimensionHeight: "29,7 cm",
      artworkCreationDate: "2017",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Filtry to praca kolaż na którą składają się 4 odrębne prace. Składają się na nią prostokątne tekturowe podkładki, które były wykorzystywane jako podkładki na farbę przy malowaniu  obrazów strukturalnych oraz filtry fotograficzne otrzymane od jednego z operatorów na Camerimage w Bydgoszczy przytwierdzone za pomocą kleju. Praca podpisana na odwrocie.",
      artworkImages: {
        "0016-1": "images/0016/0016-1.jpg",
        "0016-2": "images/0016/0016-2.jpg",
        "0016-3": "images/0016/0016-3.jpg",
        "0016-4": "images/0016/0016-4.jpg",
        "0016-5": "images/0016/0016-5.jpg",
        "0016-6": "images/0016/0016-6.jpg",
        "0016-7": "images/0016/0016-7.jpg",
        "0016-8": "images/0016/0016-8.jpg",
        "0016-9": "images/0016/0016-9.jpg",
        "0016-10": "images/0016/0016-10.jpg",
      },
    },
*/
    "0015": {
      metaTitle: "EMBRYO",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, EMBRYO",
      artworkId: "0015",
      artworkTitle: "EMBRYO",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2016",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Obraz fakturowy, wykonany techniką kolażu. Składa się z plastikowych elementów pochodzących z wtryskarki jednej z fabryk bydgoskich. Elementy zostały przytwierdzone za pośrednictwem specjalistycznego kleju i zabezpieczone werniksem. Poza tym została użyta grubo lana farba olejna. Tytułowy embrion jest ukazany jako symboliczny twór,  który niezależnie od wszystkiego kształtuje się we własnym królestwie. Praca sygnowana podpisana na odwrocie bez możliwości wykonania kopii.",
      artworkImages: {
        "0015-1": "images/0015/0015-1.jpg",
        "0015-2": "images/0015/0015-2.jpg",
        "0015-3": "images/0015/0015-3.jpg",
        "0015-4": "images/0015/0015-4.jpg",
        "0015-5": "images/0015/0015-5.jpg",
        "0015-6": "images/0015/0015-6.jpg",
        "0015-7": "images/0015/0015-7.jpg",
        "0015-8": "images/0015/0015-8.jpg",
        "0015-9": "images/0015/0015-9.jpg",
        "0015-10": "images/0015/0015-10.jpg",
      },
    },

    "0014": {
      metaTitle: "INSOMNIA",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, INSOMNIA",
      artworkId: "0014",
      artworkTitle: "INSOMNIA",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2016",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Insomnia oznacza stan niewystarczającej długości snu lub niezadowalającej jego jakość. Jest to bezsenność. Jest to ciemność z przebłyskami światła. Na obraz składa się masa plastyczna przypominająca wosk, a w rzeczywistości  jest to masa powstała jako ubytek tworzywa z wtryskarek w jednej z bydgoskich fabryk. Elementy plastikowe zostały przytwierdzone do płótna za pomocą specjalistycznego kleju.  Elementy plastikowe zostały zabezpieczone lakierem. Na obraz została naniesiona gruba warstwa czarnej farby olejnej i polakierowana. Praca ma zamalowane boki i nie wymaga ramy.  Jest sygnowana i podpisana na odwrocie. ",
      artworkImages: {
        "0014-1": "images/0014/0014-1.jpg",
        "0014-2": "images/0014/0014-2.jpg",
        "0014-3": "images/0014/0014-3.jpg",
        "0014-4": "images/0014/0014-4.jpg",
        "0014-5": "images/0014/0014-5.jpg",
        "0014-6": "images/0014/0014-6.jpg",
        "0014-7": "images/0014/0014-7.jpg",
        "0014-8": "images/0014/0014-8.jpg",
        "0014-9": "images/0014/0014-9.jpg",
        "0014-10": "images/0014/0014-10.jpg",
      },
    },

    "0013": {
      metaTitle: "BRAINBLOOM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BRAINBLOOM",
      artworkId: "0013",
      artworkTitle: "BRAINBLOOM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2016",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Brainboom jest nawiązaniem do pracy Heartboom. Jest to wybuch mózgu, a raczej,  personifikacja fantazji, wyobraźni, którą ten mózg tworzy. Obraz symbolizujący zmianę, radość pozytywną ekspresję. Praca jest wykonana z wielu elementów industrialnych pochodzących z procesów skrawania oraz wtryskarek, a także materiałów organicznych jak zasuszone owoce i kości. Praca sygnowana podpisana na odwrocie.",
      artworkImages: {
        "0013-1": "images/0013/0013-1.jpg",
        "0013-2": "images/0013/0013-2.jpg",
        "0013-3": "images/0013/0013-3.jpg",
        "0013-4": "images/0013/0013-4.jpg",
        "0013-5": "images/0013/0013-5.jpg",
        "0013-6": "images/0013/0013-6.jpg",
        "0013-7": "images/0013/0013-7.jpg",
        "0013-8": "images/0013/0013-8.jpg",
      },
    },

    "0012": {
      metaTitle: "WATERLILIES",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, WATERLILIES",
      artworkId: "0012",
      artworkTitle: "WATERLILIES",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2015",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        'Wariacja na temat obrazów Clouda Moneta o tematyce "Nenufary" i interpretacja utworu Björk "Black Lake". Obraz fakturowy wykonany techniką mieszaną za pomocą kolażu. Składa się z opiłków metal pochodzących z procesu skrawania, przytwierdzonych do płótna za pomocą specjalistycznego kleju, zasuszonych części australijskiej rośliny, Przytwierdzonych również za pomocą specjalistycznego kleju, grubo lanej czarnej farby olejnej oraz werniksu zabezpieczającego obraz. Boki obrazu są zamalowane co sprawia, iż nie potrzebuje on ramy. Praca jest sygnowana i podpisana na odwrocie. Obraz jest  lekko połyskujący z błyszczącymi elementami. Podświetlony od tyłu ukazuje INNE kolory niż w normalnej odsłonie.',
      artworkImages: {
        "0012-1": "images/0012/0012-1.jpg",
        "0012-2": "images/0012/0012-2.jpg",
        "0012-3": "images/0012/0012-3.jpg",
        "0012-4": "images/0012/0012-4.jpg",
        "0012-5": "images/0012/0012-5.jpg",
        "0012-6": "images/0012/0012-6.jpg",
        "0012-7": "images/0012/0012-7.jpg",
        "0012-8": "images/0012/0012-8.jpg",
        "0012-9": "images/0012/0012-9.jpg",
        "0012-10": "images/0012/0012-10.jpg",
        "0012-11": "images/0012/0012-11.jpg",
      },
    },

    "0011": {
      metaTitle: "BLACK DAWN",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BLACK DAWN",
      artworkId: "0011",
      artworkTitle: "BLACK DAWN",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "100 cm",
      artworkCreationDate: "2015",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        '"Czarny świt w krwistej barwie coraz mocniej mnie przeraża..." Autor nieznany<br><br>Najlepszy do charakteryzacji tej pracy jest powyższy opis, na który natrafiłem przypadkowo w internecie", który poprzez swoją wyrazistość stał się podwaliną do powstania pracy. Obraz fakturowy wykonany na płótnie ma zamalowane boki dzięki czemu nie wymaga ramy. Jest wykonany z opiłków metalu pochodzących z procesu skrawania ze skrawarki, przytwierdzonych do płótna za pomocą specjalistycznego kleju. Poza tym użyta została farba olejna oraz werniks zabezpieczający. Praca sygnowana i  podpisana na odwrocie obrazu. Powierzchnia matowa  z połyskliwymi elementami. Asamblaż, STRUCTURAL COLLAGE.',
      artworkImages: {
        "0011-1": "images/0011/0011-1.jpg",
        "0011-2": "images/0011/0011-2.jpg",
        "0011-3": "images/0011/0011-3.jpg",
        "0011-4": "images/0011/0011-4.jpg",
        "0011-5": "images/0011/0011-5.jpg",
        "0011-6": "images/0011/0011-6.jpg",
        "0011-7": "images/0011/0011-7.jpg",
      },
    },

    "0010": {
      metaTitle: "HEARTBOOM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, HEARTBOOM",
      artworkId: "0010",
      artworkTitle: "HEARTBOOM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "55 cm",
      artworkCreationDate: "2014",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Heartboom oznacza dosłownie wybuch serca pod wpływem pewnych doznań, uczuć, emocji, przeżyć. Jest to pewien rodzaj wyzwolenia emocjonalnego. Obraz jest wykonany techniką asamblażu. Składa się z masy plastycznej przypominającej wosk, a będącej w rzeczywistości wypływem plastikowego tworzywa z wtryskarek, pochodzących z jednej z bydgoskich fabryk. Obraz jest sygnowany, podpisany na odwrocie.",
      artworkImages: {
        "0010-1": "images/0010/0010-1.jpg",
        "0010-2": "images/0010/0010-2.jpg",
        "0010-3": "images/0010/0010-3.jpg",
        "0010-4": "images/0010/0010-4.jpg",
        "0010-5": "images/0010/0010-5.jpg",
        "0010-6": "images/0010/0010-6.jpg",
        "0010-7": "images/0010/0010-7.jpg",
        "0010-8": "images/0010/0010-8.jpg",
      },
    },

    "0009": {
      metaTitle: "ANT(Y)-MAN",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, ANT(Y)-MAN",
      artworkId: "0009",
      artworkTitle: "ANT(Y)-MAN",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "54 cm",
      artworkDimensionHeight: "73 cm",
      artworkCreationDate: "2014",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca wykonana techniką kolażu. Zastosowana została srebrna farba olejna grubo kładziona oraz przymocowane ulane elementy, pochodzące z maszyny wtryskarka. Obraz posiada elementy wypukłe 3D przedstawionej postaci. Nawiązuje do początków swojego powstania czyli  fabryki która współcześnie często odczłowiecza naszą naturę sprowadzając nas do istot człeko - podobnych, robotów lub w tym wypadku mrówek pracujących jak w gnieździe. Obraz podpisany sygnowany na odwrocie.",
      artworkImages: {
        "0009-1": "images/0009/0009-1.jpg",
        "0009-2": "images/0009/0009-2.jpg",
        "0009-3": "images/0009/0009-3.jpg",
        "0009-4": "images/0009/0009-4.jpg",
        "0009-5": "images/0009/0009-5.jpg",
        "0009-6": "images/0009/0009-6.jpg",
      },
    },

    "0008": {
      metaTitle: "ANTHURIUM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, ANTHURIUM",
      artworkId: "0008",
      artworkTitle: "ANTHURIUM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "40 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "2013",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Obraz fakturowy, kolaż, a właściwie asamblaż. Do wykonania pracy został użyty czarny siateczkowaty materiał, fioletowy kruszony metal pochodzący z procesu skrawania oraz czarna i fioletowa farba olejna. Elementy  zostały przytwierdzone za pomocą specjalistycznego kleju do płótna. Symboliką nawiązuje do Anturium. Kruszony materiał pochodzi z bydgoskiej fabryki jest symbolicznym sercem obrazu, dzięki któremu czarny organizm żyje. Obraz sygnowany podpisany na odwrocie.",
      artworkImages: {
        "0008-1": "images/0008/0008-1.jpg",
        "0008-2": "images/0008/0008-2.jpg",
        "0008-3": "images/0008/0008-3.jpg",
        "0008-4": "images/0008/0008-4.jpg",
        "0008-5": "images/0008/0008-5.jpg",
        "0008-6": "images/0008/0008-6.jpg",
        "0008-7": "images/0008/0008-7.jpg",
      },
    },

    "0007": {
      metaTitle: "ABERRATION",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, ABERRATION",
      artworkId: "0007",
      artworkTitle: "ABERRATION",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "100 cm",
      artworkDimensionHeight: "120 cm",
      artworkCreationDate: "2008",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Obraz powstał w starej fabryce-lakierni w Bydgoszczy w której kiedyś pracowałem podczas farbowania i lakierowania innych przedmiotów. Kolaż powstał z połączenia płyty kartonowej wykorzystywanej jako podkładka w lakierni, ciętego kruszonego metalu i farby olejnej oraz płótna. Na powierzchni pracy można doszukać się wiele śladów z przeszłości w postaci plam, chlapnięć, zadrapań. Łączy w sobie ducha przeszłości, w której się narodził oraz przyszłości stając się współczesnym obrazem. Obraz jest sygnowany i podpisany na odwrocie.",
      artworkImages: {
        "0007-1": "images/0007/0007-1.jpg",
        "0007-2": "images/0007/0007-2.jpg",
        "0007-3": "images/0007/0007-3.jpg",
        "0007-4": "images/0007/0007-4.jpg",
        "0007-5": "images/0007/0007-5.jpg",
        "0007-6": "images/0007/0007-6.jpg",
        "0007-7": "images/0007/0007-7.jpg",
        "0007-8": "images/0007/0007-8.jpg",
      },
    },

    "0006": {
      metaTitle: "DION",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, DION",
      artworkId: "0006",
      artworkTitle: "DION",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "70 cm",
      artworkDimensionHeight: "110 cm",
      artworkCreationDate: "2008",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Historia obrazu jest iście industrialna gdyż powstał on w starej fabryce-lakierni w Bydgoszczy w której kiedyś pracowałem podczas farbowania i lakierowania innych przedmiotów. Praca powstała z dwóch części: płyty kartonowej oraz płótna. Dodatkowo została wykorzystana farba olejna w różnych kolorach i warstwach na płycie kartonowej. Udział swój w powstaniu pracy miała maszyna wykorzystywana do mieszania farby. Mieszając farbę dokonywała rozbryzgu na podkładkę, która teraz stanowi główny trzon obrazu. Na pracy widać ślady lakieru, będącego jednym z podstawowych materiałów stosowanych w lakierni.",
      artworkImages: {
        "0006-1": "images/0006/0006-1.jpg",
        "0006-2": "images/0006/0006-2.jpg",
        "0006-3": "images/0006/0006-3.jpg",
        "0006-4": "images/0006/0006-4.jpg",
        "0006-5": "images/0006/0006-5.jpg",
      },
    },

    "0005": {
      metaTitle: "RCD 500",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, RCD 500",
      artworkId: "0005",
      artworkTitle: "RCD 500",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "54 cm",
      artworkDimensionHeight: "74 cm",
      artworkCreationDate: "2008",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Kolaż powstały podczas pracy w fabryce - lakierni w Bydgoszczy. Część kartonowa wykorzystywana także podczas lakierowania i malowania detali w lakierni przytwierdzona do płótna i pokryta warstwami farby olejnej i pastelami. Obraz zmienia częściowo barwy w zależności od rodzaju oświetlenia. Wyrażenie RCD 500 symbolicznie nawiązuję do podkładek kartonowych wykorzystywanych w lakierni ale równie dobrze może oznaczać daleką, nieodkrytą nam jeszcze galaktykę. Obraz sygnowany podpisany na odwrocie.",
      artworkImages: {
        "0005-1": "images/0005/0005-1.jpg",
        "0005-2": "images/0005/0005-2.jpg",
        "0005-3": "images/0005/0005-3.jpg",
        "0005-4": "images/0005/0005-4.jpg",
        "0005-5": "images/0005/0005-5.jpg",
        "0005-6": "images/0005/0005-6.jpg",
      },
    },

    "0004": {
      metaTitle: "SM",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, SM",
      artworkId: "0004",
      artworkTitle: "SM",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "46 cm",
      artworkDimensionHeight: "53 cm",
      artworkCreationDate: "2007",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "SM oznacza Something mechanical, Stright maschine, strange material. Historia obrazu nawiązuje do klimatu industrialnego, gdyż elementy, które zawiera pochodzą z fabryki. Składa się z opiłków metalu pochodzących ze skrawarki z procesu skrawania oraz ciętego kruszonego fioletowego metalu, przytwierdzonego za pośrednictwem specjalistycznego kleju do drewnianej płyty pilśniowej. Płyta ma nierówny kształt, grubość około 8 mm, poza opiłkami metalu składa się z grubo lanej warstwy srebrnej farby olejnej na tło oraz smoły z procesu smołowania dachu w środku obrazu. Ostre elementy, ciemne barwy jak i nierówne krawędzie pracy nadają jej surowego charakteru. Praca jest sygnowana na odwrocie.",
      artworkImages: {
        "0004-1": "images/0004/0004-1.jpg",
        "0004-2": "images/0004/0004-2.jpg",
        "0004-3": "images/0004/0004-3.jpg",
        "0004-4": "images/0004/0004-4.jpg",
        "0004-5": "images/0004/0004-5.jpg",
      },
    },

    "0003": {
      metaTitle: "FLORA",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, FLORA",
      artworkId: "0003",
      artworkTitle: "FLORA",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "40 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "2006",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca wykonana techniką mieszaną przy użyciu kolażu. Zastosowane zostały organiczne materiały roślINNE, gruba warstwa farby olejnej, sprayu i kleju. Praca została zrobiona na starej płycie pilśniowej. RoślINNE elementy postaci zostały, zawerniksowane i zabezpieczone przed uszkodzeniem, następnie pomalowane i przytwierdzone za pomocą specjalistycznego kleju do płyty pilśniowej. Boki zamalowane o grubości 8 mm. Obraz ukazuje roślinny charakter postaci będącej jednocześnie personifikacją natury, roślINNEj bogini. Siły, jaką natura posiada z jednej strony niezwykłej, z drugiej strony szokującej i przerażającej. Sygnowany i podpisany na odwrocie. Bez możliwości wykonania kopii.",
      artworkImages: {
        "0003-1": "images/0003/0003-1.jpg",
        "0003-2": "images/0003/0003-2.jpg",
        "0003-3": "images/0003/0003-3.jpg",
        "0003-4": "images/0003/0003-4.jpg",
        "0003-5": "images/0003/0003-5.jpg",
        "0003-6": "images/0003/0003-6.jpg",
      },
    },

    "0002": {
      metaTitle: "GRILLE",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, GRILLE",
      artworkId: "0002",
      artworkTitle: "GRILLE",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "40 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "2006",
      artworkAvailability: "SPRZEDANY",
      artworkDescription:
        "Praca wykonana techniką kolażu. Na jej elementy składa się lekko krzywa płyta pilśniowa, sprężyna od starego łóżka przedstawiająca ową kratę, przytwierdzona za pomocą kleju oraz kładzione grubą warstwą farby olejne. Praca zawerniksowana, sygnowana na odwrocie. Puste pola stanowiące przestrzenie po przetarciu się nakładających się na siebie sprężyn symbolizują pewien błąd, wyrwany z kontekstu rzeczywistości. Inspirowana dokumentem  o obozie koncentracyjnym Auschwitz-Birkenau.",
      artworkImages: {
        "0002-1": "images/0002/0002-1.jpg",
        "0002-2": "images/0002/0002-2.jpg",
        "0002-3": "images/0002/0002-3.jpg",
        "0002-4": "images/0002/0002-4.jpg",
      },
    },

    "0001": {
      metaTitle: "BLACK WOMAN",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, BLACK WOMAN",
      artworkId: "0001",
      artworkTitle: "BLACK WOMAN",
      artworkCycle: "STRUCTURAL COLLAGE",
      artworkWidth: "1",
      artworkDimensionWidth: "40 cm",
      artworkDimensionHeight: "60 cm",
      artworkCreationDate: "2006",
      artworkAvailability: "DOSTĘPNY",
      artworkDescription:
        "Praca wykonana na płycie pilśniowej pochodzącej ze starych mebli. Obraz wykonany z tkaniny jutowej znalezionej na strychu w połączeniu z czarnym kruszonym szkłem wykorzystywanym w procesie spawania oraz przyklejonym pyłem pochodzącym ze szlifowania starych ponad 100- letnich dachówek ceramicznych. Elementy przytwierdzone do płyty za pomocą odpowiedniego kleju i zabezpieczone werniksem. Całość pokryta czarną smolistą farbą oraz czerwoną farbą olejną. Wszystkie elementy przedstawione na obrazie łączy zamierzchła przeszłość i przyszłość w postaci wizerunku kobiety. Obraz sygnowany, podpisany na odwrocie. Bez możliwości wykonania kopii.",
      artworkImages: {
        "0001-1": "images/0001/0001-1.jpg",
        "0001-2": "images/0001/0001-2.jpg",
        "0001-3": "images/0001/0001-3.jpg",
        "0001-4": "images/0001/0001-4.jpg",
        "0001-5": "images/0001/0001-5.jpg",
      },
    },

    "0000": {
      metaTitle: "W strukturze mroku",
      metaDescription: "",
      metaKeywords: "Structuralist, STRUCTURAL COLLAGE, W strukturze mroku",
      artworkId: "0074",
      artworkTitle: "W strukturze mroku",
      artworkCycle: "POEZJA",
      artworkDimensionWidth: "",
      artworkDimensionHeight: "",
      artworkCreationDate: "",
      artworkAvailability: "",
      artworkDescription: "",
      artworkImages: {
        "": "",
      },
    },
  },

  // EXHIBITIONS
  exhibitions: {
    exhibitionsHeader: "Wystawy",
    exhibitionsContainer: {
      "0007": {
        exhibitionTitle: '"BIOART" - wystawa prac w Palmiarni poznańskiej',
        exhibitionDate: " listopad 2021 - grudzień 2021",
        exhibitionDescription:
          "BIOART -  ma w zamiarze ukazać obcowanie natury ze sztuką, dosłownie i w przenośni. Sztuka  powraca na łono natury. Powstała dzięki w większości naturalnym elementom pochodzenia organicznego, swoistym darom natury, wraca na jej łono, aby podać się samej naturze i złożyć jej hołd.  Zamierzeniem ma być zjednoczenie się sztuki z naturą, ukazanie jak natura dokonuje zmian na pracach, w miarę możliwości przekształca je, a w ostateczności sztuka, staje się częścią, elementem składowym  natury. Sztuka wynika z natury i w naturę wnika. Krąg się zamyka. Prace znajdowały się w pawilonach nr 4, 5 i 9 Palmiarni poznańskiej, ukazane pośród różnej scenerii: od roślinności tropikalnej, poprzez pustynną czy subtropikalną. Wystawione na działanie warunków klimatycznych i środowiskowych Palmiarni.",
        exhibitionLink1:
          "https://palmiarnia.poznan.pl/pl/14-prezentacja-oferty/577-bioart-wystawa-palmiarni-poznanskiej-od-20-listopada",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "../../../images/exhibitions/BioArt.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0007/0001.jpg",
          "0002": "images/exhibitions/0007/0002.jpg",
          "0003": "images/exhibitions/0007/0003.jpg",
          "0004": "images/exhibitions/0007/0004.jpg",
          "0005": "images/exhibitions/0007/0005.jpg",
          "0006": "images/exhibitions/0007/0006.jpg",
          "0007": "images/exhibitions/0007/0007.jpg",
          "0008": "images/exhibitions/0007/0008.jpg",
          "0009": "images/exhibitions/0007/0009.jpg",
          "0010": "images/exhibitions/0007/0010.jpg",
          "0011": "images/exhibitions/0007/0011.jpg",
          "0012": "images/exhibitions/0007/0012.jpg",
          "0013": "images/exhibitions/0007/0013.jpg",
          "0014": "images/exhibitions/0007/0014.jpg",
          "0015": "images/exhibitions/0007/0015.jpg",
          "0016": "images/exhibitions/0007/0016.jpg",
          "0017": "images/exhibitions/0007/0017.jpg",
          "0018": "images/exhibitions/0007/0018.jpg",
          "0019": "images/exhibitions/0007/0019.jpg",
          "0020": "images/exhibitions/0007/0020.jpg",
          "0021": "images/exhibitions/0007/0021.jpg",
          "0022": "images/exhibitions/0007/0022.jpg",
          "0023": "images/exhibitions/0007/0023.jpg",
          "0024": "images/exhibitions/0007/0024.jpg",
          "0025": "images/exhibitions/0007/0025.jpg",
          "0026": "images/exhibitions/0007/0026.jpg",
        },
      },

      "0006": {
        exhibitionTitle:
          "Wystawa sztuki współczesnej z kolekcji Piotra Fajkisa w Kopalni Ignacy w Rybniku",
        exhibitionDate: "styczeń 2020 – luty 2020",
        exhibitionDescription:
          "Zgromadzone dzieła na wystawie prezentuję polskich artystów młodego pokolenia takich jak Paweł Baśnik, Patryk Różycki, Piotr Owczarek, czy Paweł Tymcio, ale nie tylko. W jego kolekcji znajdują się również starsi, dojrzali twórcy, jak choćby Kazimierz Rafalik, Piotr Młodożeniec, Wilhelm Sasnal, Iza Staręga, Dorota Nieznalska lub Norman Leto. Zaprezentowana została także praca Michała Króla „Sieć” .",
        exhibitionLink1:
          "http://www.rybnik.com.pl/wiadomosci,wystawa-sztuki-wspolczesnej-na-ignacym,wia5-3267-43345.html",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "../../../images/exhibitions/WystawaPiotraFajkisa.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0006/0001.jpg",
          "0002": "images/exhibitions/0006/0002.jpg",
          "0003": "images/exhibitions/0006/0003.jpg",
          "0004": "images/exhibitions/0006/0004.jpg",
        },
      },

      "0005": {
        exhibitionTitle:
          "Jasinski&friends VII - wystawa sztuki w Galerii Przy Teatrze w Warszawie",
        exhibitionDate: "listopad 2019 – styczeń 2020",
        exhibitionDescription:
          "Siódma edycja zbiorowej wystawy sztuki Jasinski&friends. Organizowana przez Dominika Jasińskiego wraz z Galerią Przy Teatrze Narodowym w Warszawie. Zaprezentowano prace 26 - ciu polskich artystów, od malarstwa przez grafikę po fotografię. Na wystawie można było zobaczyć trzy prace autorstwa Michała Króla pt. „Earth Skull”, „Golden Skul” „Copper Skull”.",
        exhibitionLink1: "http://www.facebook.com/events/3070138143000323/",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "/../../images/exhibitions/Jasiński&Friends.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0005/0001.jpg",
          "0002": "images/exhibitions/0005/0002.jpg",
          "0003": "images/exhibitions/0005/0003.jpg",
          "0004": "images/exhibitions/0005/0004.jpg",
          "0005": "images/exhibitions/0005/0005.jpg",
          "0006": "images/exhibitions/0005/0006.jpg",
          "0007": "images/exhibitions/0005/0007.jpg",
          "0008": "images/exhibitions/0005/0008.jpg",
          "0009": "images/exhibitions/0005/0009.jpg",
          "0010": "images/exhibitions/0005/0010.jpg",
        },
      },

      "0004": {
        exhibitionTitle:
          "„INTERIOR” - Wernisaż prac w galerii Popartgaleria w Poznaniu",
        exhibitionDate: "październik 2018 – listopad 2018",
        exhibitionDescription:
          "Rentgen pokazuje nam coś niewidocznego, naszą wewnętrzną powłokę, strukturę, materię organiczną ukazaną przez maszynę. Jest metaforą INTERIORU czyli WNĘTRZA. Nie chodzi o fizyczne wnętrze, ono jest tylko pretekstem, ale wnętrze emocjonalne, ukazane pod postacią barw różnego rodzaju wynikłych z doznań i doświadczeń, emocjonalnych, muzycznych, fizycznych , erotycznych, które są w naszym wnętrzu osadzone, jak plamy koloru nałożone na tych zdjęciach. Jest to też hołd złożony muzyce elektronicznej, techno, która niesie cząstkę futuryzmu, mroku, nowoczesności oraz techniczności i surowości jak maszyna RTG, która stała się narzędziem diagnostycznym działania, artystycznego.",
        exhibitionLink1: "http://www.facebook.com/events/254804431892324/",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "../../images/exhibitions/INTERIORPoznań.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0004/0001.jpg",
          "0002": "images/exhibitions/0004/0002.jpg",
          "0003": "images/exhibitions/0004/0003.jpg",
          "0004": "images/exhibitions/0004/0004.jpg",
          "0005": "images/exhibitions/0004/0005.jpg",
          "0006": "images/exhibitions/0004/0006.jpg",
          "0007": "images/exhibitions/0004/0007.jpg",
          "0008": "images/exhibitions/0004/0008.jpg",
          "0009": "images/exhibitions/0004/0009.jpg",
          "0010": "images/exhibitions/0004/0010.jpg",
          "0011": "images/exhibitions/0004/0011.jpg",
          "0012": "images/exhibitions/0004/0012.jpg",
          "0013": "images/exhibitions/0004/0013.jpg",
          "0014": "images/exhibitions/0004/0014.jpg",
          "0015": "images/exhibitions/0004/0015.jpg",
          "0016": "images/exhibitions/0004/0016.jpg",
          "0017": "images/exhibitions/0004/0017.jpg",
          "0018": "images/exhibitions/0004/0018.jpg",
        },
      },

      "0003": {
        exhibitionTitle:
          "XXI Międzynarodowy Kongres Ochrony Środowiska Envicon Environment",
        exhibitionDate: "październik 2017 – październik 2017",
        exhibitionDescription:
          "Tematy poruszane podczas ENVICON-u oraz informacje i wiedza na najwyższym poziomie merytorycznym co roku przyciągają około pół tysiąca uczestników. Kongres to sprawdzone forum, w którym udział biorą najważniejsi reprezentanci administracji rządowej i samorządowej, przedstawiciele polskich i zagranicznych przedsiębiorstw, eksperci w dziedzinach gospodarki odpadami i gospodarki wodno-ściekowej, a także wykorzystywania surowców wtórnych i rozsądnego zarządzania środowiskiem i ekologią. W ramach wykorzystania surowców wtórnych oraz w nawiązaniu do tematyki ZERO WASTE projekt STUKTURAL COLLAGE został poproszony o pokazanie możliwości wykorzystania produktów ubocznych procesów produkcyjnych w ujęciu artystycznym. Tym samym można było dostrzec, iż tematyka ZERO WASTE & ART mogą być ze sobą tożsame.",
        exhibitionLink1: "http://www.facebook.com/events/1413554982060525/",
        exhibitionLink2:
          "http://www.facebook.com/envicon.abrys/posts/1851582358193016",
        exhibitionLink3: "",
        exhibitionImage: "/../images/exhibitions/EnviconPoznań.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0003/0001.jpg",
          "0002": "images/exhibitions/0003/0002.jpg",
          "0003": "images/exhibitions/0003/0003.jpg",
        },
      },

      "0002": {
        exhibitionTitle:
          "Wernisaż pt. STRUCTURAL COLLAGE w Geranium Caffe w Poznaniu",
        exhibitionDate: "czerwiec 2017 – wrzesień 2017",
        exhibitionDescription:
          "Wernisaż odbył się w jednej z bardziej interesujących kawiarni i restauracji Poznania Geranium Caffe Vege Kuchnia. Kawiarnia będąca zdecydowanie jedną z ulubienic mieszkańców Jeżyc, stawia przede wszystkim na siły natury w swojej kuchni oraz filozofii kulinarnej, jednocześnie prezentując pełne przyrody i harmonii wnętrza. Zgodziła się zaprezentować prace będące w pewien sposób zaprzeczeniem procesów natury, a stanowiące raczej abstrakcyjne twory powstałe przy współdziałaniu maszyny z człowiekiem. W ten sposób postawiła sobie jedną poprzeczkę wyżej, celowo uwrażliwiając swoich gości, często stałych bywalców, na inny wymiar rzeczywistości, w którym toporny świat maszyn, miesza się z abstrakcyjnym myśleniem człowieka. Stając się jednocześnie przestrzenią, która tak jak kuchnia non stop się zmienia.",
        exhibitionLink1: "http://www.facebook.com/events/1910549632553265/",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "../images/exhibitions/StructuralCollageGerranium.jpg",
        exhibitionImages: {
          "0001": "images/exhibitions/0002/0001.jpg",
          "0002": "images/exhibitions/0002/0002.jpg",
          "0003": "images/exhibitions/0002/0003.jpg",
          "0004": "images/exhibitions/0002/0004.jpg",
          "0005": "images/exhibitions/0002/0005.jpg",
          "0006": "images/exhibitions/0002/0006.jpg",
          "0007": "images/exhibitions/0002/0007.jpg",
          "0008": "images/exhibitions/0002/0008.jpg",
          "0009": "images/exhibitions/0002/0009.jpg",
          "0010": "images/exhibitions/0002/0010.jpg",
          "0011": "images/exhibitions/0002/0011.jpg",
          "0012": "images/exhibitions/0002/0012.jpg",
          "0013": "images/exhibitions/0002/0013.jpg",
          "0014": "images/exhibitions/0002/0014.jpg",
          "0015": "images/exhibitions/0002/0015.jpg",
          "0016": "images/exhibitions/0002/0016.jpg",
          "0017": "images/exhibitions/0002/0017.jpg",
          "0018": "images/exhibitions/0002/0018.jpg",
          "0019": "images/exhibitions/0002/0019.jpg",
          "0020": "images/exhibitions/0002/0020.jpg",
          "0021": "images/exhibitions/0002/0021.jpg",
          "0022": "images/exhibitions/0002/0022.jpg",
          "0023": "images/exhibitions/0002/0023.jpg",
          "0024": "images/exhibitions/0002/0024.jpg",
          "0025": "images/exhibitions/0002/0025.jpg",
          "0026": "images/exhibitions/0002/0026.jpg",
          "0027": "images/exhibitions/0002/0027.jpg",
          "0028": "images/exhibitions/0002/0028.jpg",
        },
      },

      "0001": {
        exhibitionTitle:
          "Wystawa i happening pt. STRUCTURAL COLLAGE w Bydgoszczy",
        exhibitionDate: "marzec 2017 – maj 2017",
        exhibitionDescription:
          "Wystawa odbyła się w XIV filii Wojewódzkiej i Miejskiej Biblioteki Publicznej w Bydgoszczy położonej przy jednej z głównych ulic. Zamierzeniem projektu było wyjście ze sztuką do zwykłych obywateli miasta i obcowanie z nią „twarzą w twarz”, a także „wciągnięcie” obywateli w projekt tworzenia wielkiego kolażu kuturowo – społecznego: biblioteka-sztuka-ulica. Użyta została do tego ogromna witryna okienna biblioteki, w której rozmieszczone zostały wyróżniające się kolorystycznie prace, których celem było zwrócenie uwagi zwykłego pieszego i zachęcenie go do zatrzymania się i obcowania ze sztuką, która poniekąd wychodzi do niego na przeciw. Jednocześnie zachęcając zwykłych obywateli do przestąpienia progów biblioteki. Wystawa prac była jednocześnie happeningiem mającym na celu zwrócenie uwagi zwykłych mieszkańców na sztukę, spotkaną na swojej drodze, zachęcenie ich do poznania jej bliżej, a w dalszej konsekwencji obcowania z kulturą poprzez swoją obecność w bibliotece.",
        exhibitionLink1: "http://www.facebook.com/events/290218671399627/",
        exhibitionLink2: "",
        exhibitionLink3: "",
        exhibitionImage: "./images/exhibitions/StructuralCollageBydgoszcz.jpg",
        exhibitionImages: {},
      },
    },
  },

  // BIOGRAPHY
  biography: {
    biographyHeader: "O mnie",
    biographyParagraph:
      "Urodzony w 1984 r. pochodzi z Kujaw. Tytuł magistra uzyskał kończąc studia na wydziale Pedagogiki i Psychologii w Katedrze Filozofii Edukacji i Pedagogiki Kultury Uniwersytetu Kazimierza Wielkiego w Bydgoszczy. Dotychczas prace były realizowane w dwóch sektorach : STRUCTURAL COLLAGE z wykorzystaniem maszyn industrialnych, dzięki którym mogły powstać obrazy strukturalne oraz INTERIOR czyli wgląd do wnętrza dosłownie i w przenośni dzięki zdjęciom rentgenowskim oraz pochodzącym z rezonansu magnetycznego. Inspiracje do swojej twórczości czerpał z pracy w bydgoskich fabrykach, w których pracował w wolnym czasie i okresie studenckim. Stamtąd pochodzą także elementy wykorzystywane w jego twórczości. Posługuje się głównie asamblażem i kolażem. Pokazuje, że elementy konstrukcyjne różnych rzeczy lub ubytki w procesie produkcyjnym mogą zaistnieć na nowo, nowym życiem, jako obraz posiadający w sobie ducha przeszłości, a jednocześnie nową artystyczną drogę przyszłości. Inspiruje go głównie strukturalizm i industrializm oraz wszelkie ich wytwory w życiu nas otaczającym. Jednak przede wszystkim malarstwo strukturalne, fascynacja takimi artystami jak: Alberto Burri, Piotr Łakomy, Andy Warhol czy Hans Rudolf Giger. Dzięki temu może realizować jak to określa „kolaż strukturalny„. Po odbytych wizytach w Australii, Szwajcarii, Niemczech czy Wielkiej Brytanii obecnie mieszka i tworzy w Poznaniu.",
    biographyImage: "./images/biography/BiographyImage.jpg",
  },

  // CONTACT
  contact: {
    contactHeader: "Kontakt",
    contactButton: "Napisz do mnie",
    contactData: "Twoje dane",
    contactEmail: "Twój adres e-mail",
    contactMessage: "Treść wiadomości",
    contactErrorBackUp:
      "Wystąpił błąd podczas wysyłania wiadomości, wyślij ją proszę bezpośrednio na",
    contactErrorInvalidEmail: "Nieprawidłowy adres e-mail.",
    contactErrorSending: "Wysyłanie...",
    contactSuccsessSending: "Wiadomość została wysłana.",
  },
};
